import React from "react"
const BreezyIcon = () =>
  <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.62394 15.9004L2.7617 26.4186C2.58792 27.4007 3.2465 28.3372 4.23273 28.5104L17.6262 30.8625C21.4435 31.5323 25.2661 29.7115 27.1383 26.3318C29.0104 22.952 28.5179 18.761 25.9128 15.9029L4.62394 15.9004Z" fill="#00DED1"/>
  <path d="M25.9135 15.9005C27.6391 13.3663 27.958 10.1342 26.7607 7.31406C25.5634 4.49394 23.0129 2.46986 19.9851 1.93695L8.95557 0L8.92281 0.0281458C8.05535 0.0437706 7.32053 0.669059 7.16977 1.51988L4.62341 15.9005H25.9135Z" fill="#0163FA"/>
  <path d="M16.8364 19.7195L4.33582 17.5273L5.59551 10.4141L20.7747 13.0796C22.7558 13.4243 24.5645 14.4181 25.9137 15.9031C23.9063 18.8439 20.3528 20.3378 16.8364 19.7195Z" fill="#0056CD"/>
  </svg>

export default BreezyIcon
